import { render, staticRenderFns } from "./StoryfinderResult.vue?vue&type=template&id=56bc5056&scoped=true"
import script from "./StoryfinderResult.vue?vue&type=script&lang=js"
export * from "./StoryfinderResult.vue?vue&type=script&lang=js"
import style0 from "./StoryfinderResult.vue?vue&type=style&index=0&id=56bc5056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bc5056",
  null
  
)

export default component.exports